// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__lrqVo","content":"styles_content__MN7ns","desktopLayout":"styles_desktopLayout__R8JB0","topBarButton":"styles_topBarButton__hGep_"};